export const omit = (obj, keys) => {
  if (!obj) {
    return {};
  }
  const invalidKeys = new Set(keys);
  return Object.fromEntries(Object.entries(obj).filter(([key]) => !invalidKeys.has(key)));
};